import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetAllStates } from '../../screen/auth/action/util_actions';
import {
  GetAllCityOfState,
  getLocationAndPincodeAction,
  getpricingGeographyAction,
} from '../Onboarding/auth/action';

import { IcotermsDropDown, deliveryTypeDropDown } from '../../utils/settings';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const ShipToPartyDetailsComponents = ({
  firm = {},
  setBuyerDetails = () => {},
  isSellToBuyer = false,
  editFirm = false,
  handleEditDeliveryDetails = () => {},
  showSaveButton = false,
  influencerTabSelected = false,
}) => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firmDetails, setfirmDetails] = useState(firm);
  const [pricingGeographyList, setPricingGeographyList] = useState([]);

  const {
    addedUserList,
    booking_details,
    isFmcgFlow,
    isPaintFlow,
    seller_id,
    supplier_id,
    booking_editorder_details,
    isDeliveryAddressSameAsConsigneeAddress,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      booking_details: state.bcmOrderReducer.booking_details,
      isFmcgFlow: state.bcmOrderReducer.isFmcgFlow,
      isPaintFlow: state.bcmOrderReducer.isPaintFlow,
      seller_id: state.bcmOrderReducer.seller_id,
      supplier_id: state.bcmOrderReducer.supplier_id,
      booking_editorder_details:
        state.bcmOrderReducer.booking_editorder_details,
      isDeliveryAddressSameAsConsigneeAddress:
        state.bcmOrderReducer.isDeliveryAddressSameAsConsigneeAddress,
    };
  });
  const [sellerID, setSellerID] = useState(
    booking_details?.seller_company_id ||
      seller_id ||
      booking_editorder_details?.order_details?.supplier_id,
  );

  const [buyer, setBuyer] = useState({
    ...firm,
    delivery_type:
      isFmcgFlow || isPaintFlow ? null : deliveryTypeDropDown[0].value,
    delivery_district_id: firm?.delivery_district_id
      ? firm?.delivery_district_id
      : firm?.district_id,
    delivery_Address_line1: firm?.delivery_Address_line1
      ? firm?.delivery_Address_line1
      : firm?.company_address1,
    delivery_Address_line2: firm?.delivery_Address_line2
      ? firm?.delivery_Address_line2
      : firm?.company_address2,
    delivery_Address_line3: firm?.delivery_Address_line3
      ? firm?.delivery_Address_line3
      : firm?.company_address3,
    location_id: firm?.location_id,
    location_name: firm?.location_name,
    pricing_geography_id: firm?.pricing_geography_id,
    pricing_geography_name: firm?.pricing_geography_name,
    delivery_location_id: firm?.delivery_location_id
      ? firm?.delivery_location_id
      : firm?.location_id,
    delivery_location_name: firm?.delivery_location_name
      ? firm?.delivery_location_name
      : firm?.location_name,
    delivery_pricing_geography_id: firm?.delivery_pricing_geography_id
      ? firm?.delivery_pricing_geography_id
      : firm?.pricing_geography_id,
    delivery_pricing_geography_name: firm?.delivery_pricing_geography_name
      ? firm?.delivery_pricing_geography_name
      : firm?.pricing_geography_name,
    delivery_company_pincode: firm?.delivery_company_pincode
      ? firm?.delivery_company_pincode
      : firm?.company_pincode,
  });
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [checked, setChecked] = useState(true);
  const [allPincodes, setAllPincodes] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [firstSelection, setFirstSelection] = useState(null);

  const getlocationPincode = async (
    districtId,
    locationId = null,
    PincodeId = null,
  ) => {
    if (PincodeId && buyer.delivery_location_id) return;
    if (locationId && buyer.delivery_company_pincode) return;
    const { data, error } = await getLocationAndPincodeAction(districtId, {
      location_id: locationId,
      pincode_id: PincodeId,
    });
    if (!error) {
      if (locationId && !buyer.delivery_company_pincode) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
      } else if (PincodeId && !buyer.delivery_location_id) {
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      } else if (!locationId && !PincodeId) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      }
    }
  };
  const getGeographyPricing = async ({ district_id }) => {
    const params = new URLSearchParams();
    params.append('district_id', district_id);
    params.append('manufacturer_id', sellerID);

    const { data, error, message } = await getpricingGeographyAction(params);

    if (!error) {
      setPricingGeographyList(
        data.map((vv) => ({
          label: vv.pricing_geography_name,
          value: vv.pricing_geography_id,
        })),
      );
    } else return toast.error(message);
  };

  useEffect(() => {
    setBuyerDetails(buyer);
  }, [buyer]);

  const getStates = async () => {
    const { data, error, message } = await GetAllStates();

    if (!error) {
      setStates(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        })),
      );
    } else {
      return toast.error(message);
    }
  };

  const getDistricts = async (stateId) => {
    setDistricts([]);

    const { data, error, message } = await GetAllCityOfState(stateId);

    if (!error) {
      setDistricts(
        data.map((district) => ({
          label: district.district_name,
          value: district.id,
        })),
      );
    } else return toast.error(message);
  };

  useEffect(() => {
    if (buyer.state_id) getDistricts(buyer.state_id);
  }, [buyer.state_id]);

  useEffect(() => {
    if (buyer?.delivery_district_id) {
      getlocationPincode(buyer.delivery_district_id);
      !influencerTabSelected &&
        getGeographyPricing({ district_id: buyer.delivery_district_id });
    }
  }, [buyer.delivery_district_id]);

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
    if (editFirm) {
      dispatch({
        type: 'SET_DELIVERY_ADDRESS_SAME_AS_CONSIGNEE_ADDRESS',
        data: false,
      });
    }
  }, [editFirm]);

  useEffect(() => {
    if (buyer.delivery_company_pincode) {
      getlocationPincode(
        buyer.delivery_district_id,
        null,
        buyer.delivery_company_pincode,
      );
    }
  }, [buyer.delivery_company_pincode]);

  useEffect(() => {
    if (buyer.delivery_location_id) {
      getlocationPincode(
        buyer.delivery_district_id,
        buyer.delivery_location_id,
        null,
      );
    }
  }, [buyer.delivery_location_id]);
  return (
    <Box>
      <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
        <Typography
          variant='h6'
          gutterBottom
        >
          Basic Details
        </Typography>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            sm={6}
          >
            <TextField
              fullWidth
              label='Firm Name'
              variant='outlined'
              disabled
              defaultValue={buyer.company_name}
              value={buyer.company_name}
              onChange={(e) =>
                setBuyer((prev) => ({ ...prev, company_name: e.target.value }))
              }
            />
          </Grid>
          {!influencerTabSelected && (
            <Grid
              item
              xs={12}
              sm={6}
            >
              <TextField
                fullWidth
                label='GSTN'
                variant='outlined'
                defaultValue={buyer.gstin}
                value={buyer.gstin}
                disabled
              />
            </Grid>
          )}
        </Grid>
      </Paper>

      {!editFirm && (
        <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
          <Typography
            variant='h6'
            gutterBottom
          >
            Consignee Details
          </Typography>
          <Grid
            container
            spacing={2}
          >
            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControl fullWidth>
                <InputLabel disabled>State</InputLabel>
                <Select
                  value={buyer.state_id}
                  disabled
                  label={'State'}
                  onChange={(e) => {
                    setBuyer((prev) => ({ ...prev, state_id: e.target.value }));
                  }}
                >
                  {states.map((state) => {
                    return (
                      <MenuItem value={state.value}>{state.label}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControl fullWidth>
                <InputLabel disabled>District</InputLabel>
                <Select
                  value={buyer.district_id}
                  disabled
                  label='District'
                  onChange={(e) => {
                    setBuyer((prev) => ({
                      ...prev,
                      district_id: e.target.value,
                    }));
                  }}
                >
                  {districts.map((district) => {
                    return (
                      <MenuItem value={district.value}>
                        {district.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid
              item
              xs={12}
              sm={6}
            >
              <FormControl fullWidth>
                <InputLabel disabled>Location</InputLabel>
                <Select
                  value={buyer.location_id}
                  disabled
                  label='Location'
                >
                  <MenuItem value={buyer.location_id}>
                    {buyer.location_name}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {!influencerTabSelected && (
              <Grid
                item
                xs={12}
                sm={6}
              >
                <FormControl fullWidth>
                  <InputLabel disabled>Pricing Geography</InputLabel>
                  <Select
                    value={buyer.pricing_geography_id}
                    disabled
                    label='Pricing Geography'
                  >
                    <MenuItem value={buyer.pricing_geography_id}>
                      {buyer.pricing_geography_name}
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid
              item
              xs={12}
            >
              <TextField
                fullWidth
                label='Address Line 1'
                variant='outlined'
                defaultValue={buyer.company_address1}
                value={buyer.company_address1}
                disabled
                onChange={(e) =>
                  setBuyer((prev) => ({
                    ...prev,
                    company_address: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <TextField
                fullWidth
                label='Address Line 2'
                variant='outlined'
                defaultValue={buyer.company_address2}
                value={buyer.company_address2}
                disabled
                onChange={(e) =>
                  setBuyer((prev) => ({
                    ...prev,
                    company_address: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <TextField
                fullWidth
                label='Address Line 3'
                variant='outlined'
                defaultValue={buyer.company_address3}
                value={buyer.company_address3}
                disabled
                onChange={(e) =>
                  setBuyer((prev) => ({
                    ...prev,
                    company_address: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
            >
              <FormControl fullWidth>
                <InputLabel disabled>Pincode</InputLabel>
                <Select
                  value={buyer.company_pincode}
                  label={'Pincode'}
                  disabled
                >
                  <MenuItem value={buyer.company_pincode}>
                    {buyer.company_pincode}
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      )}

      <Paper
        sx={{
          padding: 3,
          borderRadius: 2,
          mb: 3,
          display: influencerTabSelected ? 'none' : 'block',
        }}
      >
        <Typography
          variant='h6'
          gutterBottom
        >
          Delivery Details
        </Typography>
        <Grid
          container
          spacing={2}
        >
          {!editFirm && (
            <Grid
              item
              xs={12}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    name='useSameAsConsignee'
                    checked={isDeliveryAddressSameAsConsigneeAddress}
                    color='primary'
                    onClick={() => {
                      setChecked((prev) => !prev);
                      setBuyer((prev) => ({
                        ...prev,
                        delivery_Address_line1: buyer?.company_address1,
                        delivery_Address_line2: buyer?.company_address2,
                        delivery_Address_line3: buyer?.company_address3,
                        delivery_location_id: buyer?.location_id,
                        delivery_pricing_geography_id:
                          buyer?.pricing_geography_id,
                        delivery_district_id: buyer.district_id,
                        delivery_company_pincode: buyer.company_pincode,
                      }));
                      dispatch({
                        type: 'SET_DELIVERY_ADDRESS_SAME_AS_CONSIGNEE_ADDRESS',
                        data: !isDeliveryAddressSameAsConsigneeAddress,
                      });
                    }}
                  />
                }
                label='Use Same As Consignee Details'
              />
            </Grid>
          )}
          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled>State</InputLabel>
              <Select
                value={buyer.state_id}
                label={'State'}
                disabled
                onChange={(e) => {
                  setBuyer((prev) => ({ ...prev, state_id: e.target.value }));
                }}
              >
                {states.map((state) => {
                  return <MenuItem value={state.value}>{state.label}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                District
              </InputLabel>
              <Select
                id='demo-simple-select-label'
                value={buyer.delivery_district_id || ''}
                label='District'
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                onChange={(e) => {
                  const found = districts.find(
                    (d) => d.value === e.target.value,
                  );
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_district_id: e.target.value,
                    delivery_district_name: found.label,
                    delivery_location_id: null,
                    delivery_location_name: null,
                    delivery_pricing_geography_id: null,
                    delivery_pricing_geography_name: null,
                    delivery_company_pincode: null,
                    delivery_Address_line1: '',
                    delivery_Address_line2: '',
                    delivery_Address_line3: '',
                  }));
                  setFirstSelection(null);
                }}
              >
                {districts.map((district) => {
                  return (
                    <MenuItem value={district.value}>{district.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                Location
              </InputLabel>
              <Select
                value={buyer?.delivery_location_id || ''}
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                label='Location'
                onChange={(e) => {
                  const found = allCities.find(
                    (d) => d.value === e.target.value,
                  );
                  if (!firstSelection) setFirstSelection('city');
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_location_id: e.target.value,
                    delivery_location_name: found.label,
                    ...(firstSelection === 'city'
                      ? { delivery_company_pincode: null }
                      : {}),
                  }));
                }}
              >
                {allCities.map((location) => {
                  return (
                    <MenuItem value={location.value}>{location.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                Pricing Geography
              </InputLabel>
              <Select
                value={buyer?.delivery_pricing_geography_id}
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                label='Pricing Geography'
                onChange={(e) => {
                  const found = pricingGeographyList.find(
                    (d) => d.value === e.target.value,
                  );
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_pricing_geography_id: e.target.value,
                    delivery_pricing_geography_name: found.label,
                  }));
                }}
              >
                {pricingGeographyList.map((pricingGeography) => {
                  return (
                    <MenuItem value={pricingGeography.value}>
                      {pricingGeography.label}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              fullWidth
              label='Address line 1'
              variant='outlined'
              disabled={isDeliveryAddressSameAsConsigneeAddress}
              defaultValue={buyer.delivery_Address_line1}
              value={buyer.delivery_Address_line1}
              onChange={(e) =>
                setBuyer((prev) => ({
                  ...prev,
                  delivery_Address_line1: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              fullWidth
              label='Address line 2'
              variant='outlined'
              disabled={isDeliveryAddressSameAsConsigneeAddress}
              defaultValue={buyer.delivery_Address_line2}
              value={buyer.delivery_Address_line2}
              onChange={(e) =>
                setBuyer((prev) => ({
                  ...prev,
                  delivery_Address_line2: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              fullWidth
              label='Address line 3'
              variant='outlined'
              disabled={isDeliveryAddressSameAsConsigneeAddress}
              defaultValue={buyer.delivery_Address_line3}
              value={buyer.delivery_Address_line3}
              onChange={(e) =>
                setBuyer((prev) => ({
                  ...prev,
                  delivery_Address_line3: e.target.value,
                }))
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={4}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                Pincode
              </InputLabel>
              <Select
                value={buyer.delivery_company_pincode}
                label={'Pincode'}
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                onChange={(e) => {
                  if (!firstSelection) setFirstSelection('pincode');
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_company_pincode: e.target.value,
                    ...(firstSelection === 'pincode'
                      ? {
                          delivery_location_id: null,
                          delivery_location_name: '',
                        }
                      : {}),
                  }));
                }}
              >
                {allPincodes.map((pincode) => {
                  return (
                    <MenuItem value={pincode.value}>{pincode.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>

          {!isSellToBuyer && (
            <Grid
              item
              xs={12}
              sm={4}
            >
              <TextField
                fullWidth
                label='Contact Person Name'
                variant='outlined'
                onChange={(e) => {
                  setBuyer({
                    ...buyer,
                    delivery_contact_person_name: e.target.value,
                  });
                }}
                value={buyer.delivery_contact_person_name}
                defaultValue={buyer.delivery_contact_person_name}
              />
            </Grid>
          )}

          {!isSellToBuyer && (
            <Grid
              item
              xs={12}
              sm={4}
            >
              <TextField
                fullWidth
                label='Contact Person No.'
                variant='outlined'
                value={buyer.delivery_contact_person_phone}
                defaultValue={buyer.delivery_contact_person_phone}
                onChange={(e) => {
                  setBuyer({
                    ...buyer,
                    delivery_contact_person_phone: e.target.value,
                  });
                }}
              />
            </Grid>
          )}
          {!isSellToBuyer && (
            <Grid
              sx={{
                marginTop: '2rem',
                marginLeft: '1rem',
              }}
            >
              <TextField
                label='Dispatch Date'
                type='date'
                InputLabelProps={{ shrink: true }}
                value={dayjs(buyer?.dispatch_date).format('YYYY-MM-DD')}
                defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                sx={{ mr: 2 }}
                onChange={(e) => {
                  setBuyer((prev) => ({
                    ...prev,
                    dispatch_date: dayjs(e.target.value).format('YYYY-MM-DD'),
                  }));
                }}
              />
            </Grid>
          )}
        </Grid>
      </Paper>

      {!(isFmcgFlow || isPaintFlow || isSellToBuyer) && (
        <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
          <Typography
            variant='h6'
            gutterBottom
          >
            Shipment Details
          </Typography>
          <Grid
            container
            spacing={2}
            direction={'row'}
          >
            <Grid
              item
              xs={6}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel>Delivery Type</InputLabel>
                <Select
                  value={buyer.delivery_type}
                  label='Delivery Type'
                  onChange={(e) => {
                    setBuyer((prev) => ({
                      ...prev,
                      delivery_type: e.target.value,
                    }));
                  }}
                  sx={{}}
                >
                  {deliveryTypeDropDown.map((type) => {
                    return <MenuItem value={type.value}>{type.label}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid
              item
              xs={6}
            >
              <FormControl sx={{ width: '100%' }}>
                <InputLabel>Incoterm</InputLabel>
                <Select
                  value={buyer.incoterms}
                  defaultValue={IcotermsDropDown[1].value}
                  label='Incoterm'
                  onChange={(e) => {
                    setBuyer((prev) => ({
                      ...prev,
                      incoterms: e.target.value,
                    }));
                  }}
                >
                  {IcotermsDropDown.map((item) => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Paper>
      )}
      {showSaveButton && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 2,
            mb: '2rem',
          }}
        >
          <Button
            variant='contained'
            color='primary'
            sx={{
              width: '20%',
              fontWeight: 'bold',
            }}
            onClick={() => {
              handleEditDeliveryDetails(buyer);
              toast.success('Delivery details saved successfully');
            }}
          >
            {'Save'}
          </Button>
        </Box>
      )}
    </Box>
  );
};
export default ShipToPartyDetailsComponents;
